import { z } from 'zod';

export const commentSchema = z.object({
  body: z
    .string()
    .trim()
    .min(1, 'Write something before posting')
    .max(2000, 'Comment must be 2000 characters or fewer'),
});
export type CommentInput = z.infer<typeof commentSchema>;
